import axios from 'axios'
import {Loading} from 'element-ui'
import {serialize} from '@/util'
import {getToken,removeToken} from './auth'
// import oauth from './oauth'
import router from '../router'

axios.defaults.timeout = 60 * 1000 * 5; //响应超时时间    

//请求拦截器
axios.interceptors.request.use(
  config => {
    config.headers.Authorization = getToken()
    //在data里的isSerialize是true的话 就 序列化 data
    if (config.method === 'post' && config.data.isSerialize) {
      config.data = serialize(config.data);
    }

    return config
  },
  err => {
    return Promise.reject(err)
  }
);
let loading
 
function dealRequest(url,params,funName,isLoading = true) {
  return new Promise((resolve, reject) => {
    if(isLoading) {
      loading = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-loading-spinner',
        background: 'rgba(0, 0, 0, 0.7)'
      })    
    }
    axios[funName](url, params)
      .then(response => {
        console.log(router.currentRoute.fullPath)
        console.log(window.location)

       console.log('到请求')
        resolve(response['data'])
      },(err)=>{
        reject(err)
      })
      .catch((err) => {
    console.log('到请求拦截')

        console.error(err)
      })
  })
}
const CancelToken=axios.CancelToken
const source=CancelToken.source()
//添加响应拦截器
axios.interceptors.response.use((res) =>{
  if(loading) { 
    loading.close()
  }
  if(res.data.code === 401) {
    source.cancel();//发现401取消所有请求
    console.log('到响应拦截401')
    console.log(router.currentRoute.fullPath)
    let isPath=router.currentRoute.fullPath.indexOf('redirect_url')!=-1?router.currentRoute.fullPath:'';
    let paths=''
    if(isPath){
      const url = window.location;
      paths= url.origin +'/auth' +isPath;
      console.log(paths)
    }
     removeToken();
    //  let historyPath=`${isPath} || '/login'}`
     router.push({path:'/login',query:{fromUrl:paths || ''}})
    // ad域免登录不用
    // return new Promise((resolve) => {
    //   oauth().then(auth => {
    //     if(auth) {
    //       res.config.headers.Authorization = auth
    //       resolve(axios.request(res.config))
    //     }
    //     return auth
    //   })
    // })
    return Promise.reject(res)
  } else {
    return Promise.resolve(res)
  }
}, (error) => {
  if(loading) { 
    loading.close()
  }

  return Promise.reject(error)
})
//返回一个Promise(发送post请求)
export function post(url, params,isLoading = false) {
  return dealRequest(url,params,"post",isLoading);
}
//返回一个Promise(发送get请求)
export function get(url,params,isLoading = false) {
  return dealRequest(url, {params},"get",isLoading);
}
//返回一个Promise(发送put请求)
export function put(url, params, isLoading = false) {
  return dealRequest(url, params, "put", isLoading);
}
//返回一个Promise(发送delete请求)
export function del(url, params, isLoading = false) {
  return dealRequest(url, {params}, "delete", isLoading);
}
export default {
  post,
  get,
  put,
  del,
}